module.exports = __webpack_public_path__ + "img/standard-icon7.d94320e.svg";